import React from 'react';
import { Button } from './Button';

export const AccountButton = props => (
  <Button {...props}>
    <i className="far fa-user" />
  </Button>
);
